import ProducersMap from './ProducersMap';

export default ProducersMap;
